<form-card *transloco="let t;">
    <div class="form-card">
        <div class="h-full flex flex-col items-center">
            <div class="w-40">
                <img [src]="marketingSettings.kmonLogoPath" />
            </div>
            <p *ngIf="!marketingSettings.welcomeBackLabel" class="mt-15 text-3xl font-medium">
                {{t(!isForgotPsw?'signIn.welcomeBack':'signIn.forgotPsw') |
                uppercase}}</p>
            <p *ngIf="marketingSettings.welcomeBackLabel" class="mt-15 text-3xl font-medium">
                {{!isForgotPsw ? marketingSettings.welcomeBackLabel : t('signIn.forgotPsw') |
                uppercase}}</p>
            <ng-container *ngIf="!isForgotPsw; else forgotPsw">
                <form class="w-full flex flex-col items-center" [formGroup]="signInFormGroup">
                    <!-- Form Control -->
                    <input class="w-full mt-6 mb-4" type="text"
                        [placeholder]="t('shared.username') + ' / ' + t('shared.email')" pInputText
                        formControlName="username" />
                    <div class="password-container w-full relative">
                        <input class="w-full" [type]="!isPasswordVisible ? 'password':'text'"
                            [placeholder]="t('shared.password')" pInputText formControlName="password" />
                        <fa-icon [icon]="['fas', !isPasswordVisible ? 'eye':'eye-slash']"
                            (click)="isPasswordVisible = !isPasswordVisible"></fa-icon>
                    </div>
                    <div class="ml-auto mt-2 text-k-pink text-sm underline">
                        <a [href]="helpLink" target="_blank">{{t('signIn.needHelp')}}</a>
                    </div>
                    <!-- Submit for Form -->
                    <!-- <k-button type="submit" (onClickAction)="login()"
                        [isDisabled]="!signInFormGroup.valid">{{t('signIn.login')|uppercase}}</k-button> -->
                    <k-button class="mb-3" type="submit" size="sm" buttonStyle="gradient"
                        [label]="t('signIn.login')|uppercase" (onClickAction)="login()"
                        [isDisabled]="!signInFormGroup.valid"></k-button>
                </form>
                <button type="button" (click)="isForgotPsw = true">
                    <p>{{t('signIn.forgotPswQ')}}</p>
                </button>
            </ng-container>
            <k-divider class="w-full mt-6 mb-6 lg:mt-28"></k-divider>
            <p>{{!marketingSettings.startFree?t('signIn.startFree'):marketingSettings.startFree}}
            </p>
            <a class="my-3" [routerLink]="'/sign-up'" [queryParams]="queryParam">
                <!-- <k-button>{{t('signIn.createAccont')}}</k-button> -->
                <k-button [label]="t('signIn.createAccont')"></k-button>

            </a>
        </div>
    </div>
    <ng-template #forgotPsw>
        <form class="w-full flex flex-col items-center" [formGroup]="recoveryPassFormGroup">
            <input class="w-full mt-6 mb-4" type="text" [placeholder]="t('shared.email')" pInputText
                formControlName="email" />
            <div class="flex">
                <!-- <k-button type="button" (onClickAction)="isForgotPsw = false" outline="true"
                    class="pr-3">{{t('shared.back')|uppercase}}</k-button> -->
                <k-button type="button" (onClickAction)="isForgotPsw = false" class="pr-3" buttonStyle="transparent"
                    [label]="t('shared.back')|uppercase"></k-button>
                <!-- <k-button type="submit" (onClickAction)="forgotPassword()"
                    [isDisabled]="!recoveryPassFormGroup.valid">{{t('shared.confirm')|uppercase}}</k-button> -->
                <k-button type="submit" (onClickAction)="forgotPassword()" [isDisabled]="!recoveryPassFormGroup.valid"
                    [label]="t('shared.confirm')|uppercase"></k-button>
            </div>
        </form>
    </ng-template>
</form-card>